import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "lrs_cookie_ack";

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        try {
            if (!localStorage.getItem(KEY)) {
                const t = setTimeout(() => setVisible(true), 400);
                return () => clearTimeout(t);
            }
        } catch { setVisible(true); }
    }, []);

    if (!visible) return null;

    const dismiss = () => {
        try { localStorage.setItem(KEY, "1"); } catch {}
        setVisible(false);
    };

    return (
        <div
            className="fixed left-3 right-3 md:left-6 md:right-auto md:max-w-[420px] z-40 bg-offwhite border-t-2 md:border-2 border-charcoal shadow-2xl rounded-md p-4 md:p-5 animate-slide-up"
            style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 76px)" }}
            role="dialog"
            aria-label="Cookie notice"
            data-testid="cookie-banner"
        >
            <p className="text-[13.5px] md:text-sm text-charcoal leading-relaxed">
                This website uses essential cookies to ensure it functions correctly.
                {" "}
                <Link to="/cookies" className="text-terracotta underline underline-offset-2 hover:text-terracotta-600" data-testid="cookie-banner-learn-more">
                    Learn more
                </Link>
                .
            </p>
            <div className="mt-3 flex justify-end">
                <button
                    onClick={dismiss}
                    className="font-manrope font-semibold text-terracotta text-sm px-4 py-1.5 border border-terracotta rounded-md hover:bg-terracotta hover:text-offwhite transition-colors"
                    data-testid="cookie-banner-ok"
                >
                    OK
                </button>
            </div>
        </div>
    );
}
